/**
 * Adds f_auto,q_auto to any Cloudinary upload URL so the CDN
 * auto-selects the best format (WebP/AVIF) and compresses quality.
 * Non-Cloudinary URLs are returned unchanged.
 *
 * "https://res.cloudinary.com/.../upload/v123/photo.jpg"
 *  → "https://res.cloudinary.com/.../upload/f_auto,q_auto/v123/photo.jpg"
 */
export const optimizeCloudinaryUrl = (url, { width } = {}) => {
  if (!url || !url.includes("res.cloudinary.com")) return url;

  const transforms = ["f_auto", "q_auto"];
  if (width) transforms.push(`w_${width}`);

  return url.replace("/upload/", `/upload/${transforms.join(",")}/`);
};
